import { useState, createContext, useContext } from "react";

const CategoryContext = createContext<number>(null);
const SetCategoryContext = createContext<React.Dispatch<
  React.SetStateAction<number>
> | null>(null);

const CategoryContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [activatedCategory, setActivatedCategory] = useState<number>();

  return (
    <CategoryContext.Provider value={activatedCategory}>
      <SetCategoryContext.Provider value={setActivatedCategory}>
        {children}
      </SetCategoryContext.Provider>
    </CategoryContext.Provider>
  );
};

export function useCategoryContext() {
  return useContext(CategoryContext);
}

export function useSetCategoryContext() {
  return useContext(SetCategoryContext);
}

export default CategoryContextProvider;
